
////////////////////////////////////
// M062 port calculator

var _portCalculatorInitialized = false;

function initPortCalculator(){
    
	if($(".portCalculator").length > 0){
		showPortCalculatorPage1();
	}
}

function showPortCalculatorPage1(){
	$(".portCalculatorPage").hide();

	$(".portCalculator").find(".form-field").removeClass("error");
	
	var $btnNext = $("#portCalculatorPage1").find(".portCalculatorButton-next")
	$btnNext.addClass("disabled");
	updatePortCalculatorPage1Button();
	$("#portCalculatorPage1").find("#berth").on("keyup", updatePortCalculatorPage1Button);
	
	$btnNext.unbind().click(validatePortCalculatorPage1);
	$btnNext.on("keydown", handleKeyDownForClick);
	
	updateFormField2Placeholders();
	$("#portCalculatorPage1").show();
	
	if(_portCalculatorInitialized){
		scrollToPortCalculator();
	}

	_portCalculatorInitialized = true;
}
function showPortCalculatorPage2(){
	$(".portCalculatorPage").hide();

	$(".portCalculator").find(".form-field").removeClass("error");
	
	var $btnNext = $("#portCalculatorPage2").find(".portCalculatorButton-next");
	$btnNext.addClass("disabled");
	updatePortCalculatorPage2Button();
	
	$("#portCalculatorPage2").find(".portCalculatorButton-prev").unbind().click(showPortCalculatorPage1);
	$("#portCalculatorPage2").find(".portCalculatorButton-next").unbind().click(validatePortCalculatorPage2);
	$("#portCalculatorPage2").find(".portCalculatorButton-prev").on("keydown", handleKeyDownForClick);
	$("#portCalculatorPage2").find(".portCalculatorButton-next").on("keydown", handleKeyDownForClick);
	
	$(".portCalculatorVariant").removeClass("portCalculatorVariant--active");
	$("#portCalculatorPage2").find(".portCalculatorVariant").unbind().click(function(){
		$(".portCalculatorVariant").removeClass("portCalculatorVariant--active");
		$(this).addClass("portCalculatorVariant--active");
		
		$(".portCalculatorVariant").find(".portCalculator__radio").prop( "checked", false );
		$(this).find(".portCalculator__radio").prop( "checked", true );
		
		updatePortCalculatorPage2Button();
	});
	$("#portCalculatorPage2").find(".portCalculatorVariant").on("keydown", handleKeyDownForClick);
	
	$("#portCalculatorPage2").show();
	scrollToPortCalculator();
}
function showPortCalculatorPage3(){
	
	//result page
	var $variant = null;
	if($(".portCalculatorVariant--active").length > 0){
		$variant = $(".portCalculatorVariant--active");
	}
	else if($(".portCalculatorVariant--single").length > 0){
		$variant = $(".portCalculatorVariant--single");
	}
	
	if($variant){
		var $resultA = $variant.find(".portCalculatorVariant-value--a");
		var $resultB = $variant.find(".portCalculatorVariant-value--b");
		var $resultC = $variant.find(".portCalculatorVariant-value--c");
		$("#portCalculatorResultValueA").html($resultA.html());
		$("#portCalculatorResultValueB").html($resultB.html());
		$("#portCalculatorResultValueC").html($resultC.html());
		
		if($('#variant1').is(':checked')){
			$("#hiddenVariant").val(1);
		}
		else{
			$("#hiddenVariant").val(2);
		}
		$("#hiddenSum").val($resultA.attr("data-value"));
		$("#hiddenDeductable").val($resultB.attr("data-value"));
		$("#hiddenPremium").val($resultC.attr("data-value"));
	}
	
	var resultBerth = $("#berth").val();
	$("#portCalculatorResultBerth").html(resultBerth);
	
	$(".portCalculatorPage").hide();
	$("#portCalculatorPage3").find(".portCalculatorButton-prev").unbind().click(function(){
		if($(".portCalculatorVariant--single").length > 0){
			showPortCalculatorPage1();
		}
		else{
			showPortCalculatorPage2();
		}
	});
	$("#portCalculatorPage3").find(".portCalculatorButton-prev").on("keydown", handleKeyDownForClick);
	
	$("#portCalculatorPage3").find(".portCalculatorButton-next").unbind().click(function(){
		validatePortCalculatorPage3(true);
	});
	$("#portCalculatorPage3").find(".portCalculatorButton-next").on("keydown", handleKeyDownForClick);

	$(".portCalculator").find(".form-field").removeClass("error");
	$("#portCalculatorPage3").show();
	scrollToPortCalculator();
}

function scrollToPortCalculator(){
	var offset = $(".portCalculator").offset().top;
	$('html, body').animate({
		scrollTop: offset
	}, 500);
}

function updatePortCalculatorPage1Button(){
	var $btn = $("#portCalculatorPage1").find(".portCalculatorButton-next");
	$btn.removeClass("disabled");
	var berth = $("#berth").val();
	if(berth == "" || isNaN(berth) || parseInt(berth) <= 0){
		$btn.addClass("disabled");
	}
}

function updatePortCalculatorPage2Button(){
	var $btn = $("#portCalculatorPage2").find(".portCalculatorButton-next");
	$btn.removeClass("disabled");
	if(!$('#variant1').is(':checked') && !$('#variant2').is(':checked')) { 
		$btn.addClass("disabled");
	}
}

function updatePortCalculatorPage3Button(){
	var $btn = $("#portCalculatorPage3").find(".portCalculatorButton-next");
	$btn.removeClass("disabled");
	var formError = validatePortCalculatorPage3(false);
	if(formError) { 
		$btn.addClass("disabled");
	}
}

function submitPortCalculatorForm(){
	//console.log("SUBMIT!");

	$(".portCalculatorForm").submit();
}

function validatePortCalculatorPage1(){
	
	var error = false;
	$(".portCalculator").find(".form-field").removeClass("error");
	
	//page 1 "berth"
	var berth = $("#portCalculatorPage1").find("#berth").val();
	if(berth == "" || isNaN(berth) || parseInt(berth) <= 0){
		error = true;
		$("#portCalculatorPage1").find("#berth").parent(".form-field").addClass("error");
	}
	if(!error){
		calculatePortCalculatorVariants();
	}
}
function validatePortCalculatorPage2(){

	var error = false;
	$(".portCalculator").find(".form-field").removeClass("error");
	
	//page 2 "variants"
	if(!$('#variant1').is(':checked') && !$('#variant2').is(':checked')) { 
		error = true;
		$("#portCalculatorPage2").find(".form-field").addClass("error");
	}
	if(!error){
		showPortCalculatorPage3();
	}
}


function validatePortCalculatorPage3(submit){
	var error = false;

	$(".portCalculator").find(".form-field").removeClass("error");
	
	//page 3 "personal data"
	var e = checkFormErrors($("#portCalculatorPage3"));
	if(e > 0){
		error = true;
	}

	
	if(!$("#portCalculatorPage3").find("#accept").is(':checked')) { 
		error = true;
		if(submit){
			$("#portCalculatorPage3").find("#accept").closest(".form-field").addClass("error");
		}
	}
	
	if(submit){
		if(!error){
			submitPortCalculatorForm();
		}
		else{
			scrollToError();
		}
	}

	return error;
}

function calculatePortCalculatorVariants(){
	var berth = parseInt($("#portCalculatorPage1").find("#berth").val());
	var showV1 = false;

	var $v1radio = $("#portCalculatorVariant1").find(".portCalculatorVariant-radio");
	var $v2radio = $("#portCalculatorVariant2").find(".portCalculatorVariant-radio");
	$v1radio.find("input").prop('checked', false);
	$v2radio.find("input").prop('checked', false);
	

	//Jahresprämie
	var v1Value = 750;		
	var v2Value = 1500;

	if(berth <= 300){
		//max 300 berths
		v2Value = 5 * berth;	// 5 EUR
		if(v2Value < 1500){
			v2Value = 1500;
		}
		
		if(berth <= 200){
			showV1 = true;	

			v1Value = 6 * berth;	// 6 EUR
			if(v1Value < 750){
				v1Value = 750;
			}

			v1Value += (v1Value*0.19);	//19% tax

			//set value
			$("#portCalculatorVariant1Value").html(roundPortCalculatorValue(v1Value) + " €");
			$("#portCalculatorVariant1Value").siblings("input").val(v1Value);
			$("#portCalculatorVariant1Value").attr("data-value", v1Value);
		}
		
	}
	else if(berth <= 500){
		//301 => 500 berths
		v2Value = 4 * berth;	// 4 EUR
		if(v2Value < 1500){
			v2Value = 1500;
		}
	}
	else if(berth <= 750){
		//501 => 750 berths
		v2Value = 3 * berth;	// 3 EUR
		if(v2Value < 2100){
			v2Value = 2100;
		}
	}
	else{
		//more than 750 berths
		v2Value = 2 * berth;	// 2 EUR
		if(v2Value < 2500){
			v2Value = 2500;
		}
	}
	
	$("#portCalculatorVariant2").removeClass("portCalculatorVariant--single");

	if(showV1){
		//show v1
		$("#portCalculatorVariant1").parent("div").show();
		$("#portCalculatorVariant1").show();
		$(".portCalculatorVariant-title").show();
		$(".portCalculatorVariant-radio").show();

		$("#portCalculatorPage2").find(".portCalculatorBlocklabel").show();
		$("#portCalculatorPage2").find(".portCalculatorBlocklabel--single").hide();
	}
	else{
		//show only v2
		$("#portCalculatorVariant1").parent("div").hide();
		$("#portCalculatorVariant1").hide();
		$(".portCalculatorVariant-title").hide();
		$(".portCalculatorVariant-radio").hide();
		
		$("#portCalculatorVariant2").addClass("portCalculatorVariant--single");
		
		$("#portCalculatorPage2").find(".portCalculatorBlocklabel").hide();
		$("#portCalculatorPage2").find(".portCalculatorBlocklabel--single").show();

		$('#variant2').prop('checked', true);
		updatePortCalculatorPage2Button();
	}

	v2Value += (v2Value*0.19);	//19% tax

	$("#portCalculatorVariant2Value").html(roundPortCalculatorValue(v2Value) + " €");
	$("#portCalculatorVariant2Value").siblings("input").val(v2Value);
	$("#portCalculatorVariant2Value").attr("data-value", v2Value);
	
	$("#portCalculatorVariant2").show();

	//show variants
	if(showV1){
		showPortCalculatorPage2();
	}
	else{
		showPortCalculatorPage3();
	}
}

function roundPortCalculatorValue(v){
	var floor = Math.floor(v);
	var c = v-floor;

	result = "" + v;

	var cString = "";
	if(c > 0){
		var c100 = Math.round(c*100);
		if(c100 >= 10){
			cString = "" + c100;
		}
		else{
			cString = "0" + c100;
		}

		result = numberWithDots(floor) + "," +  cString;
	}
	else{
		result = numberWithDots(v);
	}

	return result;
}